import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  DuplicateExperienceRequestPathParamType,
  DuplicateExperienceResponseBodyType,
} from "@intelligems/ig-types";
import { EXPERIMENT_ROUTES, PERSONALIZATION_ROUTES } from "@src/routes/routes";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { experienceKeys, offerKeys } from "../queryKeys";
import { redirectKeys } from "../redirects/use-and-set-redirects-by-experience-id";
import { ApiRequest } from "../types/api";

const duplicateExperience = async (
  payload: ApiRequest<undefined, DuplicateExperienceRequestPathParamType>
): Promise<DuplicateExperienceResponseBodyType> => {
  const resp = await api.post<DuplicateExperienceResponseBodyType>(
    `/v2/experiences/${payload.pathParams.experienceId}/duplicate`,
    null
  );
  return resp.data;
};

export const useDuplicateExperience = (
  category: "experiment" | "personalization"
) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation<
    DuplicateExperienceResponseBodyType,
    Error,
    ApiRequest<any, DuplicateExperienceRequestPathParamType>
  >({
    mutationFn: async (data) => duplicateExperience(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey:
          category === "experiment"
            ? experienceKeys.experimentList
            : experienceKeys.personalizationList,
      });
      void queryClient.invalidateQueries({ queryKey: redirectKeys.all });
      void queryClient.invalidateQueries({ queryKey: offerKeys.all });
      toast.success(
        category === "experiment"
          ? "Experiment Duplicated"
          : "Experience Duplicated"
      );
      if (
        category === "experiment" &&
        !window.location.pathname.includes("experiments")
      ) {
        void navigate(EXPERIMENT_ROUTES.Experiments);
      }

      if (
        category === "personalization" &&
        !window.location.pathname.includes("personalizations")
      ) {
        void navigate(PERSONALIZATION_ROUTES.Personalizations);
      }
    },
  });
};
